module.exports = __webpack_public_path__ + "img/credit-card.8a074627.svg";